export default {
  shareButton: 'Share this booking',
  shareDialog: {
    dialogTitle: 'Share this booking to other',
    title: 'Booking at "{0}"'
  }
}